"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCompletedGroceryItemsMutationOptions = exports.deleteCompletedGroceryItemsMutation = void 0;
const client_1 = require("@apollo/client");
const groceryItems_1 = require("../queries/groceryItems");
exports.deleteCompletedGroceryItemsMutation = client_1.gql `
  mutation DeleteCompletedGroceryItems {
    deleteCompletedGroceryItems {
      ok
    }
  }
`;
exports.deleteCompletedGroceryItemsMutationOptions = (variables) => ({
    variables,
    update: (store, { data: dataResponse }) => {
        if (!dataResponse) {
            return;
        }
        const data = store.readQuery({
            query: groceryItems_1.groceryItemsQuery,
        });
        if (data) {
            store.writeQuery({
                query: groceryItems_1.groceryItemsQuery,
                data: {
                    __typename: "Query",
                    groceryItems: {
                        __typename: "GroceryItemsResponse",
                        items: data.groceryItems.items.filter(x => !x.complete),
                        recipes: data.groceryItems.recipes,
                    },
                },
            });
        }
    },
});
//# sourceMappingURL=DeleteCompletedGroceryItems.js.map